<template>
    <div class="containerHuman">
        <human :items="model"></human>
    </div>
</template>

<script>
import Human from '../_shared/Human.vue'
export default {
  components: { Human },
  name: 'ContentTypeHuman',
  props: {
    model: Array
  }
}
</script>
<style lang="scss" scoped>

</style>
